module.exports = __webpack_public_path__ + "img/bahaodicangchu.6400af2f.png";